import axios from 'axios'

/**
 * Create an Axios Client with defaults
 */

const client = axios.create(
  {
    baseURL: process.env.NODE_ENV === 'production' ? "https://api.lmk.chat/" : "https://api.dev.lmk.chat/",
    timeout: 20000,
});

/**
 * Request Wrapper with default success/error actions
 */
const Request = function(options, token) {

    const onSuccess = function(response) {
        return response.data;
    }

    const onError = function(error) {
        console.error('Request Failed:', error.config);

        if (error.response) {
            // Request was made but server responded with something
            // other than 2xx
            console.error('Status:', error.response.status);
            // console.error('Data:', error.response.data);
            // console.error('Headers:', error.response.headers);

        } else {
            // Something else happened while setting up the request
            // triggered the error
            console.error('Error Message:', error.message);
        }

        return Promise.reject(error.response || error.message);
    }

    delete client.defaults.headers.common['Authorization'];
    if (token !== undefined) {
        client.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    }

    client.defaults.headers.common['x-lmk-app-id'] = '999999';

    return client(options)
        .then(onSuccess)
        .catch(onError);
}

export default Request;


// WEBPACK FOOTER //
// src/util/request.js